import React, { Suspense } from "react";
import { createRoot } from "react-dom/client";
import "./index.css";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import { Auth0Provider, Auth0Context } from "@auth0/auth0-react";
import history from "./utils/history";
import { getConfig } from "./config";
import AuthConfigProvider from "./context/AuthConfigProvider";
import ReactDOM from "react-dom";
import Error from "./pages/error/general";
import './i18n'; // Import the i18n configuration

// E2Eテスト用モックAuth0Provider
const MockAuth0Provider = ({ children }) => {
  const mockUser = {
    sub: 'e2e-test|12345',
    email: 'e2e-test@festaria.com',
    name: 'E2Eテストユーザー',
    email_verified: true,
    identities: [{ provider: 'festaria' }],
    festaria_id: '1234567890123',
  };

  const mockValue = {
    isAuthenticated: true,
    isLoading: false,
    user: mockUser,
    getAccessTokenSilently: () => Promise.resolve('mock-e2e-token'),
    getAccessTokenWithPopup: () => Promise.resolve('mock-e2e-token'),
    getIdTokenClaims: () => Promise.resolve({ __raw: 'mock-id-token' }),
    loginWithRedirect: () => Promise.resolve(),
    loginWithPopup: () => Promise.resolve(),
    logout: () => { window.location.href = '/'; },
  };

  return (
    <Auth0Context.Provider value={mockValue}>
      {children}
    </Auth0Context.Provider>
  );
};

// E2Eテストモードかどうかを判定
const isE2ETestMode = () => {
  return window.__E2E_TEST_MODE__ === true ||
         new URLSearchParams(window.location.search).get('e2e') === 'true';
};

const onRedirectCallback = (appState) => {
  history.push(
    appState && appState.returnTo ? appState.returnTo : window.location.pathname
  );
};

const runAfterGetConfig = async () => {
    try {
      // Please see https://auth0.github.io/auth0-react/interfaces/Auth0ProviderOptions.html
      // for a full list of the available properties on the provider
      console.log(`[runAfterGetConfig]`)
      const config = await getConfig();

      const providerConfig = {
        domain: config.configJson.domain,
        clientId: config.configJson.client_id,
        onRedirectCallback,
        authorizationParams: {
          redirect_uri: window.location.origin,
          ...(config.configJson.audience ? { audience: config.configJson.audience } : null),
        },
      };
      const root = createRoot(document.getElementById('root'));

      // E2Eテストモードの場合はMockAuth0Providerを使用
      const AuthProvider = isE2ETestMode() ? MockAuth0Provider : ({ children }) => (
        <Auth0Provider
          {...providerConfig}
          useCookiesForTransactions={true}
          useRefreshTokens={true}
          cacheLocation={'localstorage'}
        >
          {children}
        </Auth0Provider>
      );

      root.render(
        <AuthProvider>
          <AuthConfigProvider authConfig={config}>
            <Suspense fallback={<div></div>}>
              <App />
            </Suspense>
          </AuthConfigProvider>
        </AuthProvider>,
      );

      // If you want your app to work offline and load faster, you can change
      // unregister() to register() below. Note this comes with some pitfalls.
      // Learn more about service workers: https://bit.ly/CRA-PWA
      serviceWorker.unregister();
    } catch (error) {
      console.error(error);
      ReactDOM.render(
        <Error error={error.message}/>,
        document.getElementById("root")
      )
    }
}
runAfterGetConfig()